var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.76702 9.86561C10.2451 10.1421 10.8568 9.97879 11.1333 9.50073C12.0904 8.1154 13.9402 9.96 12.4235 10.8616C12.1509 11.0237 11.7944 11.2935 11.5232 11.6239C11.2665 11.9368 11.0306 12.3672 11.0029 12.896C10.9994 12.9302 10.9976 12.9649 10.9976 13C10.9976 13.5523 11.4453 14 11.9976 14C12.7598 14 12.9049 13.595 13.0513 13.1864C13.1455 12.9235 13.2403 12.6591 13.5002 12.5C14.3268 11.994 15.0002 11.0977 15.0002 10C15.0002 8.34315 13.657 7 12.0002 7C10.8885 7 9.91934 7.60518 9.40214 8.49927C9.1256 8.97733 9.28896 9.58906 9.76702 9.86561ZM10.9976 16C10.9976 15.4477 11.4453 15 11.9976 15C12.5498 15 12.9976 15.4477 12.9976 16C12.9976 16.5523 12.5498 17 11.9976 17C11.4453 17 10.9976 16.5523 10.9976 16Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c7c59760213ed5bb3519da99304a3adb.svg";
export { ForwardRef as ReactComponent };